import { Card, Grid, FormControl, LinearProgress } from "@mui/material";
import { isEmpty } from "lodash";
import breakpoints from "assets/theme/base/breakpoints";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getConnectAccounts } from "store/slice/paymentGateway/paymentGatewaySlice";
import { useMaterialUIController } from "context";
import EmptyTableRowOverlay from "components/MDEmptyOverlay/EmptyTableRowOverlay";
import { useEffect, useState } from "react";
import MDDataGrid from "components/MDDataGrid/MDDataGrid";
import moment from "moment";
import { getDepositReportAPI } from "store/slice/reports/reportSlice";
import { capitalizeFirstLetter } from "global/functions";
import CircularIndeterminate from "components/MDLoading";
import MDButton from "components/MDButton";
import * as XLSX from "xlsx";
import ReportFilterByDate from "./ReportFilterByDate";
import AddUsers from "./addUsers";

const DepositReports = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getConnectAccounts());
  }, [dispatch]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;


  const [loading, setLoading] = useState(false);
  const [openAddUsers, setOpenAddUsers] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const handleOpenAddUsers = (acc) => {
    setSelectedAccount(acc);
    setOpenAddUsers(true);
  };

  const handleCloseAddUsers = () => {
    setOpenAddUsers(false);
    setSelectedAccount(null);
  };
  const connectAccounts = useSelector((s) => s.paymentGateway?.connectAccounts || []);
  const connectAccountsLoading = useSelector((s) => s.paymentGateway?.loading);
  const roleLevel = useSelector((s) => s.users?.meInfo?.roleId?.level ?? s.users?.meInfo?.roleLevel);
  const canAddUsers = [90, 100].includes(roleLevel);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6">Connect Accounts</MDTypography>
            </MDBox>
            <MDBox>
              <Grid container spacing={2}>
                {connectAccountsLoading ? (
                  <Grid item xs={12}>Loading connect accounts...</Grid>
                ) : connectAccounts.length === 0 ? (
                  <Grid item xs={12}>No connect accounts found.</Grid>
                ) : (
                  connectAccounts.map((acc) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={acc._id}>
                      <Card sx={{ height: "100%" }}>
                        <MDBox p={2} display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                          <div>
                            <MDTypography variant="h6">{acc.title}</MDTypography>
                            <MDTypography variant="caption" color="text">
                              {/* {acc.paymentGateway} •  */}
                              {acc.connectAccountId}
                            </MDTypography>
                          </div>
                          <MDBox mt={2} display="flex" justifyContent="space-between" alignItems="center">
                            {/* <MDBox display="flex" alignItems="center" gap={1}>
                              <MDTypography variant="button" color="text">
                                Status: {acc.status === 10 ? "Active" : "Inactive"}
                              </MDTypography>
                            </MDBox> */}
                            
                            <MDButton size="small" disabled={!canAddUsers} onClick={() => handleOpenAddUsers(acc)}>
                              Add users
                            </MDButton>
                            
                            <MDButton
                              size="small"
                              onClick={() =>
                                window.open(
                                  `https://production.d3pnwlizynvip3.amplifyapp.com/?ca=${encodeURIComponent(
                                    acc.connectAccountId
                                  )}`,
                                  "_blank"
                                )
                              }
                            >
                              View
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </Grid>
                  ))
                )}
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <AddUsers dialogOpen={openAddUsers} onClose={handleCloseAddUsers} account={selectedAccount} />
      <Footer />
      <CircularIndeterminate
        type="full"
        size={20}
        text="Please wait..."
        open={loading}
      />
    </DashboardLayout>
  );
};

export default DepositReports;
